import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-illusion',
  templateUrl: './magic-uses-illusion.component.html',
  styleUrls: ['./magic-uses-illusion.component.css']
})
export class MagicUsesIllusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
